export interface Rebate {
  id: number;
  rebateType: string;
  orgLevel: string;
  redeemableAmount: number;
  redeemableType: string;
  target: number;
  targetType: string;
  paymentPeriod: string;
  startDate: Date;
  endDate: Date;
  createdBy: string;
  createdDate: Date;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  offerId: number;
}

export default class RebatesService {
  rfpsUrl = '/aptitude/api/rfps';
  cpasUrl = '/apt-admin/api/cpas';
  codeReferenceUrl = '/aptitude/api/codereferences/REBATE';

  constructor(private $http) {
    'ngInject';
  }

  getCodeReference() {
    return this.$http.get(`${this.codeReferenceUrl}`);
  }

  addRebate(rfpId: number, offerId: number, rebate: Rebate) {
    return this.$http.post(
      `${this.rfpsUrl}/${rfpId}/offers/${offerId}/rebates`,
      rebate
    );
  }

  getRebates(rfpId: number, offerId: number) {
    return this.$http.get(`${this.rfpsUrl}/${rfpId}/offers/${offerId}/rebates`);
  }

  updateRebate(
    rfpId: number,
    offerId: number,
    rebateId: number,
    rebate: Rebate
  ) {
    return this.$http.put(
      `${this.rfpsUrl}/${rfpId}/offers/${offerId}/rebates/${rebateId}`,
      rebate
    );
  }

  removeRebate(rfpId: number, offerId: number, rebateId: number) {
    return this.$http.delete(
      `${this.rfpsUrl}/${rfpId}/offers/${offerId}/rebates/${rebateId}`
    );
  }

  updateRebateProxyAuthorization(
    rfpId: number,
    offerId: number,
    rebateProxyAuthorization: boolean
  ) {
    return this.$http.put(`${this.rfpsUrl}/${rfpId}/offers/${offerId}/cpa`, {
      rebateProxyAuthorization
    });
  }

  // And the same again based upon CPA.
  addRebateByCpa(cpaId: number, rebate: Rebate) {
    return this.$http.post(`${this.cpasUrl}/${cpaId}/rebates`, rebate);
  }

  getRebatesByCpa(cpaId: number) {
    return this.$http.get(`${this.cpasUrl}/${cpaId}/rebates`);
  }

  updateRebateByCpa(cpaId: number, rebateId: number, rebate: Rebate) {
    return this.$http.put(
      `${this.cpasUrl}/${cpaId}/rebates/${rebateId}`,
      rebate
    );
  }

  removeRebateByCpa(cpaId: number, rebateId: number) {
    return this.$http.delete(`${this.cpasUrl}/${cpaId}/rebates/${rebateId}`);
  }

  updateRebateProxyAuthorizationByCpa(
    cpaId: number,
    rebateProxyAuthorization: boolean
  ) {
    return this.$http.put(`${this.cpasUrl}/${cpaId}`, {
      rebateProxyAuthorization
    });
  }
}

// TODO: Namespaces, how the APIs are imported, and other things vary between aptAdmin and the aptitude app at the
// moment. They need to be unified. Otherwise we won't be able to share this code well.
// angular.module('api').service('RebatesApi', apt.api.RebatesService);
